import { deleteField, doc, getFirestore, updateDoc } from "firebase/firestore";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useMemo, useState } from "react";
import { projectDocumentSchema } from "../../types/firestore";
import { getFirestoreZodConverter } from "../../modules/firestoreZodConverter";
import { FirebaseError } from "firebase/app";
import firebaseErrors from "../../modules/firebaseErrors";
import Spinner from "react-bootstrap/Spinner";
import Dropdown from "react-bootstrap/Dropdown";

const firestore = getFirestore();

export interface RemoveMemberProps {
	projectId: string;
	memberId: string;
}

export default function RemoveMember(props: RemoveMemberProps) {
	const [updating, setUpdating] = useState(false);
	const [error, setError] = useState<string>();

	const [showRemoveMember, setShowRemoveMember] = useState(false);

	const projectDocumentRef = useMemo(
		() =>
			doc(firestore, "Projects", props.projectId).withConverter(
				getFirestoreZodConverter(projectDocumentSchema),
			),
		[props.projectId],
	);

	useEffect(() => {
		if (!showRemoveMember) return;
		setError(undefined);
	}, [showRemoveMember]);

	return (
		<div>
			<Dropdown.Item
				onClick={() => {
					setShowRemoveMember(true);
				}}>
				Entfernen
			</Dropdown.Item>
			<Modal
				show={showRemoveMember}
				onHide={() => !updating && setShowRemoveMember(false)}
				backdrop="static"
				keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title>Benutzer entfernen</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<div className="mb-2">
						Bist du wirklich sicher, dass du diesen Benutzer aus dem Projekt entfernen möchtest?
					</div>

					{error && <div className="mb-2 text-danger">{error}</div>}
				</Modal.Body>
				<Modal.Footer>
					<Button
						disabled={!showRemoveMember || updating}
						variant="danger"
						onClick={() => setShowRemoveMember(false)}>
						Abbrechen
					</Button>
					<Button
						variant="success"
						disabled={!showRemoveMember || updating}
						onClick={async () => {
							if (!projectDocumentRef) return;

							setUpdating(true);
							setError(undefined);

							try {
								await updateDoc(projectDocumentRef, {
									["Members." + props.memberId]: deleteField(),
								});

								setUpdating(false);
								setShowRemoveMember(false);
							} catch (error) {
								if (error instanceof FirebaseError) {
									setUpdating(false);

									const message = firebaseErrors[error.code] ?? error.message;

									setError(message);
									return;
								}

								throw error;
							}
						}}>
						{updating && <Spinner className="me-1" animation="border" size="sm" />}
						Benutzer entfernen
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
